<script lang="ts">
  import { css, cx } from '@agapi/ui/panda/css';
  import { breadcrumbStyles } from '../breadcrumb.styles';
  import { ArrowLeft, CaretRight } from 'phosphor-svelte';
  import type { BreadcrumbItemProps } from '../breadcrumb.types';

  const { children, indicator, index, css: cssProp }: BreadcrumbItemProps = $props();

  const classes = breadcrumbStyles.raw({ first: index === 0 });
</script>

<li class={css(classes.item, cssProp)}>
  <div class={css(classes.indicator)}>
    {#if indicator}
      {@render indicator()}
    {:else if index === 0}
      {null}
    {:else}
      <CaretRight width={8} />
    {/if}
  </div>
  <span class={cx(css(classes.label), 'label')}>
    {#if children}
      {@render children()}
    {/if}
  </span>
</li>
